import React from "react";
import Default from "../dashboards/Default";

function ProtectedPage() {



  return (
    <React.Fragment>
      <Default />
    </React.Fragment>
  );
}

export default ProtectedPage;
